import React from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";

const RequestConfirmation = ({ open, onOk, onCancel}) => {
    return (
        <DiaglogBox width={400} onCancel={onCancel} open={open}>
            <div className="pb-5">
                <h4
                    className="pt-8 pb-9 w-full text-black text-[1.5625rem] font-bold text-center"
                    style={{
                        background: "url('/images/purple_wave_bg.svg')",
                        backgroundRepeat: "no-repeat",
                    }}
                >
                    Notification
                </h4>
                <p className="text-center text-sm font-medium px-11">
                    Are you sure you want to Transfer this credit on your
                    registry account?
                </p>
                <p className="text-center mt-2 text-[10px] font-medium px-11">
                    By doing so it will not be traded anymore on Offsetgo
                    Marketplace
                </p>
                <div className="px-10 flex justify-between mt-4">
                    <Button
                        color={"blue"}
                        className={
                            "w-[150px] h-[40px] text-white text-sm font-bold"
                        }
                        varient={"primary"}
                        onClick={onOk}
                    >
                        Yes
                    </Button>

                    <Button
                        borderColor={"blue"}
                        onClick={onCancel}
                        className={
                            "w-[150px] h-[40px] text-blue-800 text-sm font-bold"
                        }
                        varient={"primary"}
                    >
                        No
                    </Button>
                </div>
            </div>
        </DiaglogBox>
    );
};

export default RequestConfirmation;
